import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import _ from "lodash";
import Button from "react-bootstrap-button-loader";
import { showError, showSuccess } from "ReduxErrorBar";
import { fetchTemplate, addTemplate, updateTemplate } from "SettingActions";
import { COMMON_FAIL_MESSAGE } from "Constants";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import LocaleStrings from "Languages";

class SubscriptionOrder extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { loading: false };
  }

  componentDidMount() {
    // this.props.fetchTemplate(this.props.session);
  }

  onSubmitForm = (data) => {
    this.setState({ loading: true });
    var values = { ...data };
    if (!this.props.insertMode) {

      this.props.addTemplate(this.props.session, values, (response) => {
        if (response.success === 0) {
          this.props.showError(COMMON_FAIL_MESSAGE);
        } else {
          this.props.showSuccess(LocaleStrings.template_added_message);
        }
        this.setState({ loading: false });
      });
    } else {

      this.props.updateTemplate(this.props.session, values, (response) => {
        if (response.success === 0) {
          this.props.showError(COMMON_FAIL_MESSAGE);
        } else {
          this.props.showSuccess(LocaleStrings.template_updated_message);
        }
        this.setState({ loading: false });
      });
    }
  };

  render() {
    var { handleSubmit, pristine, reset, invalid, submitting } = this.props;
    
    var disabled = false;
    if (pristine || invalid || submitting) {
      disabled = true;
    }

    return (
      <form onSubmit={handleSubmit(this.onSubmitForm)}>
        <Field
          name="subscription_subject"
          label={LocaleStrings.template_setting_form_label_subject}
          placeholder={LocaleStrings.template_setting_form_ph_subject}
          type="text"
          component={this.renderFieldText}
          mandatory="true"
          labelposition={LABEL_POSITION_TOP}
        />

        <Field
          name="subscription_contenthtml"
          label={LocaleStrings.template_setting_form_label_email_content}
          placeholder={LocaleStrings.template_setting_form_ph_email_content}
          type="minimal"
          component={this.renderRichTextareaWithLabelTinymce}
          mandatory="true"
          height={500}
          labelposition={LABEL_POSITION_TOP}
        />
        <Button
          className="btn-custom-blue"
          disabled={disabled}
          loading={this.state.loading}
          type="submit"
        >
          {LocaleStrings.button_save}
        </Button>
      </form>
    );
  }
}

function validate(values) {
  var errors = {};

  var requiredFields = ["subscription_subject", "subscription_contenthtml"];
  requiredFields.forEach((field) => {
    if (!values[field] || values[field].trim() === "") {
      errors[field] = LocaleStrings.template_setting_form_validation_required;
    }
  });

  return errors;
}

function mapStateToProps(state, props) {
  // var data= _.filter(state.templateData.resource, (obj) => {return obj.templatetype === props.type });
  // var finalData = data.length > 0 ? data[0] : {}

  var initVals = null;
  var toEdit = false;
  if (
    state.templateData &&
    state.templateData.resource &&
    state.templateData.resource.length > 0
  ) {
    initVals = state.templateData.resource[0];
    toEdit = true;
  }

  return {
    session: state.session,
    insertMode: toEdit,
    initialValues: initVals,
    // templateData:state.templateData
  };
}
export default connect(mapStateToProps, {
  addTemplate,
  updateTemplate,
  showError,
  showSuccess,
  fetchTemplate,
})(
  reduxForm({
    validate,
    form: "SubscriptionOrderForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(SubscriptionOrder)
);
